// @flow

import type { Plan } from '@zapier/design-system-revenue';

const companyPlus: Plan = {
  actions: 5000000,
  amount: -1,
  allowCompanies: true,
  billingAmount: -1,
  billingInterval: 'year',
  changePlanUrl: 'https://form.jotform.com/90507635363256',
  description:
    'Automation for your whole company plus enterprise-grade features',
  descriptiveName: '',
  displayName: 'Company',
  features: [
    {
      name: 'SAML Single Sign On',
    },
    {
      name: 'Access Control for Apps',
    },
    {
      name: 'Data Export & Reporting',
    },
  ],
  featuresTag: 'Everything in Teams, plus',
  hasAutoReplay: true,
  hasDeveloperApps: true,
  hasMeteredBilling: true,
  hasMultiStepZaps: true,
  hasPaths: true,
  hasPremiumApps: true,
  hasTeams: true,
  id: -1,
  image: '',
  intervals: [],
  isCurrentPlan: false,
  isInPlanGroup: true,
  name: 'Company',
  //$FlowFixMe - This field will never be null in the real world, so this hack is in place until this file isn't needed anymore.
  selectedTaskLimitVariant: null,
  shortName: 'Company',
  taskLimitVariants: [],
  tasks: 50000,
  tiers: [],
  type: 'Company',
  zaps: -1,
  zapsRunInterval: 5,
};

export default companyPlus;
